import React from 'react';

export const AccountIcon = ({
  stroke = '#818898',
}) => {
  return (
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M20.5 21V19C20.5 16.7909 18.7091 15 16.5 15H8.5C6.29086 15 4.5 16.7909 4.5 19V21M16.5 7C16.5 9.20914 14.7091 11 12.5 11C10.2909 11 8.5 9.20914 8.5 7C8.5 4.79086 10.2909 3 12.5 3C14.7091 3 16.5 4.79086 16.5 7Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
